<div *ngIf="editOpen" id="textBlock" [innerHTML]="appText"> </div>
